import * as React from "react";

import {
  Title,
  Paragraph,
  Label,
  SubHeader,
  Text as DefaultText,
} from "../../styled-component";

function Text(props: any) {
  return <DefaultText {...props} />;
}

Text.Title = Title;
Text.SubHeader = SubHeader;
Text.Paragraph = Paragraph;
Text.Label = Label;

export default Text;
